<template lang="pug">
.c-cover-editor
  v-layout
    div(:class="$style.frame")
      div(v-if="!src") 尚未選擇圖片
      v-img(v-else
        :src="src"
        width="300"
        height="200")
    v-layout(column)
      v-btn(@click="$refs.input.click()") 選擇文章封面
      v-btn(@click="clear") 清除文章封面
      input.d-none(ref="input"
        type="file"
        accept="image/*"
        @change="uploadImage")
</template>

<script>
export default {
  name: "newCoverEditor",
  props: {
    src: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dataURL: null
    };
  },
  methods: {
    uploadImage(e) {
      const input = e.target;
      if (input.files && input.files[0]) {
        this.$emit("upload", input.files[0]);
      }
    },
    clear() {
      this.$refs.input.value = "";
      this.$emit("clear");
    }
  }
};
</script>

<style module lang="styl">
.frame
  display flex
  position relative
  width 300px
  height 200px
  border 1px black solid
  justify-content center
  align-items center
</style>
